module.exports = __webpack_public_path__ + "static/media/ic-mentee-file-off.f87365de.webp";